import { render, staticRenderFns } from "./AddNewAddressBtn.vue?vue&type=template&id=7d126048&scoped=true&lang=pug&"
import script from "./AddNewAddressBtn.vue?vue&type=script&lang=js&"
export * from "./AddNewAddressBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAddressBtn.vue?vue&type=style&index=0&id=7d126048&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d126048",
  null
  
)

export default component.exports